module.exports = __webpack_public_path__ + "0dc02e788a34421c0745e6cf56beada5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/union.jpg
// module id = 1354
// module chunks = 17